export default __webpack_public_path__ + "img/bTuXYgKV.ff47585d.svg";